import { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Files, Loader2 } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import { Input } from '../ui/input';
import { Button } from '../ui/button';
import { EMPLOYEE_DOCS } from '../employees/constants';
import { COMPANY_DOCS, COMPANY_PROFILE_DOCS } from '../companies/constants';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const GROUPS = [
  { key: 'employees', title: 'Personel Evrakları', docs: EMPLOYEE_DOCS },
  { key: 'companies', title: 'Firma Evrakları', docs: [...COMPANY_DOCS, ...COMPANY_PROFILE_DOCS] },
  { key: 'equipment', title: 'Ekipman Evrakları', docs: [
    { key: 'periyodik_muayene', label: 'Periyodik Muayene' },
    { key: 'mali_mesuliyet_sigortasi', label: 'Mali Mesuliyet Sigortası' },
    { key: 'bakim_belgesi', label: 'Bakım Belgesi' },
  ] },
];

// Süper Admin: her evrak için en fazla kaç sayfalık PDF yüklenebileceği (boş = sınırsız)
export const DocPageLimitsCard = () => {
  const [limits, setLimits] = useState(null);
  const [saving, setSaving] = useState(false);
  useEffect(() => { axios.get(`${API}/settings/doc-page-limits`).then(r => setLimits(r.data || {})); }, []);
  const set = (c, k, v) => setLimits(prev => ({ ...prev, [c]: { ...(prev[c] || {}), [k]: v === '' ? null : Math.max(1, parseInt(v, 10) || 1) } }));
  const save = async () => {
    setSaving(true);
    try { const r = await axios.put(`${API}/settings/doc-page-limits`, { limits }); setLimits(r.data); toast.success('Sayfa sınırları kaydedildi'); }
    catch (err) { toast.error(err.response?.data?.detail || 'Kaydedilemedi'); } finally { setSaving(false); }
  };
  return (
    <Card data-testid="doc-page-limits-card">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-lg"><Files className="h-5 w-5 text-orange-600" />Evrak Sayfa Sınırları</CardTitle>
        <CardDescription>Her evrak için yüklenebilecek en fazla PDF sayfa sayısı. Sınırı aşan dosya yüklenemez. Boş bırakılan evrakta sınır yoktur; 2+ sayfalı PDF'te firmaya sadece uyarı gösterilir.</CardDescription>
      </CardHeader>
      <CardContent>
        {!limits ? <Loader2 className="h-5 w-5 animate-spin text-slate-400" /> : (
          <div className="space-y-5">
            <div className="grid gap-5">
              {GROUPS.map(g => (
                <div key={g.key} className="space-y-2" data-testid={`page-limits-group-${g.key}`}>
                  <p className="text-sm font-semibold text-slate-800">{g.title}</p>
                  {g.docs.map(d => (
                    <div key={d.key} className="flex items-center justify-between gap-2 rounded-md border bg-slate-50 px-2 py-1.5">
                      <span className="text-xs text-slate-700">{d.label}</span>
                      <div className="flex items-center gap-1">
                        <Input type="number" min={1} placeholder="Sınırsız" value={limits[g.key]?.[d.key] ?? ''} onChange={(e) => set(g.key, d.key, e.target.value)}
                          className="h-8 w-24 bg-white text-right text-xs" data-testid={`page-limit-${g.key}-${d.key}`} />
                        <span className="text-[11px] text-slate-500">sayfa</span>
                      </div>
                    </div>
                  ))}
                </div>
              ))}
            </div>
            <Button onClick={save} disabled={saving} className="bg-emerald-600 text-white hover:bg-emerald-700" data-testid="page-limits-save-btn">
              {saving && <Loader2 className="mr-1 h-4 w-4 animate-spin" />}Kaydet
            </Button>
          </div>
        )}
      </CardContent>
    </Card>
  );
};
